// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignUpWithEmailMutationVariables = Types.Exact<{
  input: Types.SignUpWithEmailInput;
}>;


export type SignUpWithEmailMutation = { __typename?: 'Mutation', signUpWithEmail: { __typename?: 'AuthResult', accessToken: string } };


export const SignUpWithEmailDocument = /*#__PURE__*/ gql`
    mutation SignUpWithEmail($input: SignUpWithEmailInput!) {
  signUpWithEmail(input: $input) {
    accessToken
  }
}
    `;

/**
 * __useSignUpWithEmailMutation__
 *
 * To run a mutation, you first call `useSignUpWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpWithEmailMutation, { data, loading, error }] = useSignUpWithEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpWithEmailMutation(baseOptions?: Apollo.MutationHookOptions<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpWithEmailMutation, SignUpWithEmailMutationVariables>(SignUpWithEmailDocument, options);
      }
export type SignUpWithEmailMutationHookResult = ReturnType<typeof useSignUpWithEmailMutation>;